import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import '../pages.scss';
import Logo from '../../components/logo.mjs';


const Login = () => {
    const navigate = useNavigate();
    const [failedLogin, setFailedLogin] = useState(false);
    const [email, setEmail] = useState('');
    const [emailEmpty, setEmailEmpty] = useState(false);
    const [password, setPassword] = useState('');
    const [passwordEmpty, setPasswordEmpty] = useState(false);
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        var loader = document.querySelector(".loader");
        loader.classList.remove("hidden");

        var page = document.querySelector(".page");
        page.classList.add("blur");

        var emailElem = document.getElementById("email");
        var passElem = document.getElementById("password");

        if (email === '') {
            emailElem.style.border = 'solid 3px #C40000';
            setEmailEmpty(true);

            page.classList.remove("blur");
            loader.classList.add("hidden");

            return;
        } 

        setEmailEmpty(false);
        emailElem.style.border = '';

        if (password === '') {
            passElem.style.border = 'solid 3px #C40000';
            setPasswordEmpty(true);

            page.classList.remove("blur");
            loader.classList.add("hidden");


            return;
        }

        setPasswordEmpty(false);
        passElem.style.border = '';

        // Base64 encode credentials and swap out URL-unsafe characters which will be swapped back in on the server side
        var credentials = btoa(email + ':' + password);
        credentials = credentials.replace("/", "_").replace("+", "-");
    
        // Request to log in via syGlass backend server
        const loginRequestOptions = {
            method: 'POST',
            headers: {
                'Accept': 'application/vnd.api+json',
                'Authorization': `Basic ${credentials}` 
            }
        };
    
        var loginData;
        await fetch('/login/' + credentials  + '/', loginRequestOptions)
            .then(response => response.json())
            .then(data => {
                loginData = data;
            });
            
        // Do not make additional requests if initial login request failed
        if (loginData.user_token === '')
        {
            setFailedLogin(true);
            console.log("Login request failed.");
            loader.classList.add("hidden");
            page.classList.remove("blur");
            return;
        }
    
        // Request for additional user information (name) using the user token received from previous request
        const userInfoRequestOptions = {
            method: 'GET',
            headers: {
                'Accept': 'application/vnd.api+json',
                'Authorization': `Bearer ${loginData.user_token}` 
            }
        };
    
        await fetch('https://api.keygen.sh/v1/accounts/33459a88-6b71-4ab6-83db-e2ec6c252baf/users/' + email  + '/', userInfoRequestOptions)
        .then(response => response.json())
        .then(data => {
            setFailedLogin(false);
            sessionStorage.setItem('firstName', data.data.attributes.firstName);
            sessionStorage.setItem('lastName', data.data.attributes.lastName);
            sessionStorage.setItem('email', data.data.attributes.email);
            sessionStorage.setItem('userToken', loginData.user_token);
            sessionStorage.setItem('keygenID', loginData.keygen_id);
            sessionStorage.setItem('adminID', loginData.admin_id);

            navigate("/dashboard");
        });
    }

    const handleShowPassword = () => {
        if (password !== "") {
            const passwordField = document.getElementById("password");
            const icon = document.getElementById("icon");

            if(passwordField.type === "password") {
            passwordField.type = "text";
            icon.innerText = "visibility_off";
            }
            else {
            passwordField.type = "password";
            icon.innerText = "visibility";
            }
        }
    }

    const handleNavForgot = () => {
        navigate("/forgot-password");
    }

    const handleNavCreate = () => {
        navigate("/create-account");
    }

    const handleNavHelp = (flag) => {
        var modal = document.querySelector(".modal");
        var overlay = document.querySelector(".overlay");

        if (flag) {
            modal.classList.remove("hidden");
            overlay.classList.remove("hidden");
        } else {
            modal.classList.add("hidden");
            overlay.classList.add("hidden");
        }
    }

    const handleHelpEmail = (e) => {
        e.preventDefault();

        var fullName = document.getElementById("name");
        var helpEmail = document.getElementById("helpEmail");
        var helpBody = document.getElementById("helpBody");


        if (fullName.value !== '' && helpEmail.value !== '' && helpBody.value !== '') {
            fullName = fullName.value.toString();
            fullName = fullName.replaceAll(" ", "%20");
            helpEmail = helpEmail.value.toString();
            helpEmail = helpEmail.replaceAll(" ", "%20");
            helpBody = helpBody.value.toString();
            helpBody = helpBody.replaceAll(" ", "%20");

			const emailLink = document.createElement('a');
            emailLink.target = '_blank';
            var mailtoStr = "mailto:info@syglass.io?subject=Admin%20Dashboard%20Login%20Help&body=From:%20" + fullName.toString() + " - " + helpEmail.toString() + ". Their message: " + helpBody.toString();
			emailLink.href = mailtoStr.toString();

            document.body.appendChild(emailLink);
			emailLink.click();

            setTimeout(() => {
				document.body.removeChild(emailLink);
			}, 200);
        }
    }


    return (
        <>
            <div className="overlay hidden"></div>
            <section className="modal hidden">
            <div className="helpModal">
                <div className="helpModalHeader" style={{ marginTop:'15px', width:'534px', height:'44px', marginTop:'0px'}}>
                    <p style={{fontSize:'16px', textAlign:'left', paddingLeft:'15px', marginTop:'0px', paddingTop:'10px'}}>New message</p>
                </div>
                <div id="loginForm">
                    <p style={{fontSize:'14px', paddingTop:'0px', paddingBottom:'5px', marginBottom:'0px', textAlign:'left'}}>Name</p>
                    <input style={{marginTop:'0px'}} type="text" id="name" required placeholder="Full name"></input>

                    <p htmlFor="email" style={{fontSize:'14px', paddingTop:'0px', paddingBottom:'5px', marginBottom:'0px', textAlign:'left'}}>Email address</p>
                    <input style={{marginTop:'0px'}} type="text" id="helpEmail" name="email" required placeholder="Email"></input>

                    <p style={{fontSize:'14px', paddingTop:'0px', paddingBottom:'5px', marginBottom:'0px', textAlign:'left'}}>Message</p>
                    <textarea style={{maxHeight:'80px', maxWidth:'315px', width:'315px', height:'80px', resize:'none'}} id="helpBody" placeholder="What can we help you with?"></textarea>

                    <div style={{display:'flex', flexDirection:'row'}}>
                        <button className="btnInverse" onClick={(e) => handleNavHelp(false)} style={{display:'inline-block', width:'25% !important', marginTop:'50px', marginRight:'10px'}}>Cancel</button>
                        <button className="btn" style={{marginTop:'50px', width:'25% !important', float:'right', display:'inline-block', marginLeft:'10px'}} onClick={handleHelpEmail}>Send</button>
                    </div>
                </div>
            </div>
            </section>
        
            <div className="page">
            <div style={{marginBottom:'0px', paddingBottom:'0px'}}>
                {Logo()}
            </div>
            <div style={{margin:'auto'}}>
                <p style={{margin:'auto', marginBottom:'12px'}} className="title">Welcome to the syGlass Dashboard.</p>
            </div>
            <i className="infoIcon" style={failedLogin ? {display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}><span className="infoIcon" class="material-symbols-outlined">info</span></i>
            <p className="errorP" style={failedLogin ? {display: 'inline-block', fontSize:'16px', textAlign:'center', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}>The email and/or password you entered is incorrect. Please try again or reset your password.</p>
            <div id="loginForm">
                <p className="title" style={{fontWeight:'400', fontSize:'20px', marginBottom:'36px', marginTop:'40px'}}>Log in</p>
                <p htmlFor="email" style={{fontSize:'14px', paddingTop:'0px', paddingBottom:'5px', marginBottom:'0px', textAlign:'left'}}>Email address</p>
                <input style={{marginTop:'0px'}} type="text" id="email" name="email" onChange={(e) => setEmail(e.target.value)} required placeholder="Email"></input>
                <div style={{display:'inline-block', justifyItems:'left'}}>
                    <i className="infoIcon" style={emailEmpty ? {display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}><span className="infoIcon" class="material-symbols-outlined">info</span></i>
                    <p className="errorP" style={emailEmpty ? {display: 'inline-block', fontSize:'15px', textAlign:'center', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}>This field is required.</p>
                </div>
                <div className="passwordField" style={{marginBottom:"10px"}}>
                    <p htmlFor="password" style={{paddingBottom:'0px', marginBottom:'5px', fontSize:'14px', paddingTop:'0px', textAlign:'left'}}>Password</p>
                    <input type="password" id="password" name="password" onChange={(e) => setPassword(e.target.value)} required placeholder="Password"></input>
                    <div id="eyecon">
                        <i className="clickIcon"><span className="clickIcon" onClick={handleShowPassword} id="icon" class="material-symbols-outlined">visibility</span></i>
                    </div>
                </div>
                <div style={passwordEmpty ? {display:'inline-block', marginBottom:'0px'} : {display:'none'}}>
                    <i className="infoIcon" style={passwordEmpty ? {display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}><span className="infoIcon" class="material-symbols-outlined">info</span></i>
                    <p className="errorP" style={passwordEmpty ? {display: 'inline-block', fontSize:'15px', textAlign:'center', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}>This field is required.</p>
                </div>
                <p onClick={handleNavForgot} id="forgotPassword" className="textLineBtn" style={{fontSize:'16px', textAlign:'left', paddingTop:'0px', marginTop:'20px', marginBottom:'20px', paddingLeft:'15px'}}>Forgot password?</p>
                <button className="btn" style={{marginBottom:'20px', height:'48px', fontSize:'16px'}} onClick={(e) => handleSubmit(e)}>Log In</button>
                <div className="orDesign">
                    <div className="hrDiv"><hr className="halfHr"></hr></div>
                    <p style={{fontSize:'16px', marginTop:'0px', marginBottom:'0px'}}>or</p>
                    <div className="hrDiv"><hr className="halfHr"></hr></div>
                </div>
                <button className="btn" style={{marginTop:'20px', height:'48px', fontSize:'16px'}} onClick={handleNavCreate}>Create an account</button>
            </div>

            <p className="textLineBtn" style={{float:'right', marginTop:'60px', bottom:'0', fontSize:'14px'}} onClick={(e) => handleNavHelp(true)}>Need help?</p>
            </div>

            <div className="loader hidden loginLoader"></div>
        </>
    );
};

export default Login;